var $bc2f01fa69f1f764$exports = {};
$bc2f01fa69f1f764$exports = {
    "actions": `Radnje`,
    "actionsAvailable": `Dostupne radnje.`,
    "clearSelection": `Poni\u{161}ti odabir`,
    "selected": (args)=>`Odabrano: ${args.count}`,
    "selectedAll": `Sve je odabrano`
};


export {$bc2f01fa69f1f764$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
